import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TaskManager from './components/TaskManager';
import MultiStepForm from './components/MultiStepForm';
import DataDashboard from './components/DataDashboard';
import ConditionalWorkflow from './components/ConditionalWorkflow';
import TabsAndAccordion from './components/TabsAndAccordion';
import DragDropKanban from './components/DragDropKanban';
import SearchAndFilter from './components/SearchAndFilter';
import './EvalApp.css';

const SCENARIOS = [
  { key: 'task', label: '📋 Task Manager', desc: 'CRUD, filter, sort, modals, inline edit' },
  { key: 'form', label: '📝 Multi-Step Form', desc: 'Wizard, per-step validation, review' },
  { key: 'data', label: '📊 Data Grid', desc: 'Sorting, pagination, row selection, aggregates' },
  { key: 'logic', label: '🧮 Loan Engine', desc: 'Conditional fields, scoring, reasoning' },
  { key: 'tabs', label: '🗂 Tabs & Accordion', desc: 'Nested tabs, notifications, accordion' },
  { key: 'kanban', label: '🗃 Kanban Board', desc: 'Drag & drop, add/remove cards, columns' },
  { key: 'search', label: '🔍 Product Search', desc: 'Live search, filters, cart, wishlist' },
];

export default function EvalApp() {
  const [active, setActive] = useState('task');

  return (
    <div className="eval-wrapper">
      <div className="eval-topbar">
        <div className="eval-topbar-left">
          <span className="eval-logo">🧪</span>
          <span className="eval-topbar-title">Agent Evaluation Hub</span>
          <span className="eval-topbar-sub">LLM Computer Control Test Suite</span>
        </div>
        <Link to="/shipping" className="eval-nav-link">📦 Shipping App</Link>
        <Link to="/" className="eval-nav-link">🏠 Home</Link>
      </div>

      <div className="eval-layout">
        <nav className="eval-sidenav">
          <div className="eval-sidenav-title">Scenarios</div>
          {SCENARIOS.map(s => (
            <button
              key={s.key}
              className={`eval-nav-item ${active === s.key ? 'eval-nav-item-active' : ''}`}
              onClick={() => setActive(s.key)}
            >
              <span className="eval-nav-label">{s.label}</span>
              <span className="eval-nav-desc">{s.desc}</span>
            </button>
          ))}
          <div className="eval-sidenav-divider" />
          <div className="eval-sidenav-hint">
            <strong>How to use:</strong> Each scenario is designed to test a different agent capability. Navigate between them using this sidebar.
          </div>
        </nav>

        <main className="eval-main">
          {active === 'task' && <TaskManager />}
          {active === 'form' && <MultiStepForm />}
          {active === 'data' && <DataDashboard />}
          {active === 'logic' && <ConditionalWorkflow />}
          {active === 'tabs' && <TabsAndAccordion />}
          {active === 'kanban' && <DragDropKanban />}
          {active === 'search' && <SearchAndFilter />}
        </main>
      </div>
    </div>
  );
}
